/**
 * D19's "Update on air?": the on-air part's definition was edited, and some
 * of the changed fields are live-editable. Nothing changes on air until an
 * operator with `playout.take` confirms here (`syncToInstance`); without the
 * permission the banner says so and offers nothing.
 */
import { RefreshCwIcon } from 'lucide-react';
import { labelFor } from '../../lib/editor/fieldForm.js';
import { Button } from '../ui/button.js';

export type OnAirUpdateBannerProps = {
  readonly partTitle: string;
  /** The live-editable fields whose definition differs from what is on air. */
  readonly fields: readonly string[];
  readonly canUpdate: boolean;
  readonly pending: boolean;
  readonly onUpdate: () => void;
};

export function OnAirUpdateBanner({ partTitle, fields, canUpdate, pending, onUpdate }: OnAirUpdateBannerProps) {
  return (
    <div role="status" className="flex flex-wrap items-center gap-3 border-b border-warning bg-warning px-4 py-2 text-sm text-warning-foreground" data-testid="onair-update">
      <RefreshCwIcon className="size-4 shrink-0" aria-hidden="true" />
      <span className="min-w-0 flex-1">
        <strong>“{partTitle}” was edited while on air</strong> ({fields.map(labelFor).join(', ')}). {canUpdate ? 'Update on air?' : 'Someone with take rights can update it on air.'}
      </span>
      {canUpdate ? (
        <Button size="sm" variant="outline" className="border-warning-foreground bg-transparent" disabled={pending} onClick={onUpdate} data-testid="onair-update-confirm">
          {pending ? 'Updating…' : 'Update on air'}
        </Button>
      ) : null}
    </div>
  );
}
